import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-task-type-badge',
  template: `
    <span class="badge" [style.background-color]="getBgColor(type)" [style.color]="getColor(type)" [style.border-color]="getBorderColor(type)">
      {{ type }}
    </span>
  `,
  styles: [`
    .badge { 
        font-size: 0.65rem; 
        padding: 0.25rem 0.6rem; 
        border-radius: 4px;
        font-weight: 600;
        letter-spacing: 0.02em;
        display: inline-flex;
        align-items: center;
        border: 1px solid transparent;
    }
  `]
})
export class TaskTypeBadgeComponent {
  @Input() type: string = '';
  @Input() color: string = '';

  // Centralized color map
  private colors: { [key: string]: string } = {
    'MEETING': '#6610f2', // Purple
    'CALL': '#fd7e14',    // Orange
    'EMAIL': '#20c997',   // Teal
    'DOCUMENT': '#17a2b8', // Cyan
    'REVIEW': '#e83e8c',   // Pink
    // Add defaults
  };

  getColor(type: string): string {
    if (this.color) return this.color;
    return this.colors[type] || '#6c757d'; // Default Gray
  }

  getBgColor(type: string): string {
    const baseColor = this.getColor(type);
    return baseColor.startsWith('#') ? `${baseColor}1a` : 'rgba(108, 117, 125, 0.1)'; // 10% opacity
  }

  getBorderColor(type: string): string {
    const baseColor = this.getColor(type);
    return baseColor.startsWith('#') ? `${baseColor}33` : 'rgba(108, 117, 125, 0.2)'; // 20% opacity
  }
}
